import type { ErrorLocaleKey } from '../../../../common/error/errorLocaleKeys';
import type { TranslationFunction } from '../../../utils/errorTranslation';

type ValidationError = {
    message?: string;
    errorLocaleKey?: ErrorLocaleKey;
    context?: Record<string, unknown>;
    inner?: {
        errorLocaleKey?: ErrorLocaleKey;
        context?: Record<string, unknown>;
        [key: string]: unknown;
    };
};

/**
 * Resolves a user-facing validation error message from a field error object.
 */
export const getValidationErrorMessage = (
    error: ValidationError | null | undefined,
    translate: TranslationFunction,
): string | null => {
    if (!error?.message && !error?.errorLocaleKey && !error?.inner?.errorLocaleKey) {
        return null;
    }

    const errorLocaleKey = error.errorLocaleKey ?? error.inner?.errorLocaleKey;
    const context = error.context ?? error.inner?.context ?? {};

    if (errorLocaleKey) {
        return translate(errorLocaleKey, context);
    }

    return error.message ?? null;
};
